import * as React from 'react';

import { Text, Box, ImageContainer, Image, Divider, colors } from '../../../design-system';
import { getProductImageLink, productImageWidths } from '../../product/utils';
import { OrderItem as OrderItemType } from '../types';
import { formatPrice } from '../../common/utils';
import { LineThroughText } from '../../common/components/Custom';

type Props = {
  item: OrderItemType;
  returned?: boolean;
};

export const OrderItem = ({
  item: {
    productRef,
    colorRef,
    productName,
    detailedColorLabel,
    size,
    quantity,
    rowBaseTotal,
    rowTotal,
    bandSize,
    cupSize,
  },
  returned,
}: Props) => {
  const thumbnail = getProductImageLink({
    productRef,
    colorRef,
    productName,
    position: 1,
    width: productImageWidths.CART,
  });
  return (
    <Box display="grid" gridTemplateColumns="100px auto 50px" gridColumnGap="m">
      <Box gridColumn="1 / 4">
        <Divider my="s" />
      </Box>
      <ImageContainer>
        <Image isAbsolute src={thumbnail} alt="Product Image" />
      </ImageContainer>
      <div>
        <Box my="xs">
          <Text>{productName ?? 'Indisponible sur le Web'}</Text>
        </Box>
        <Text>Couleur : {detailedColorLabel ?? 'Indisponible sur le Web'}</Text>
        <Text>
          Taille :{' '}
          {size && size !== '0'
            ? size
            : bandSize
              ? `${bandSize} ${cupSize}`
              : 'Indisponible sur le Web'}
        </Text>
        <Text>Quantité : {Math.abs(quantity)}</Text>
        {returned && <Text color={colors.MAIN_SUCCESS}>Retourné</Text>}
      </div>
      <Box my="xs" justifySelf="center" alignSelf="start">
        {rowBaseTotal !== rowTotal && (
          <LineThroughText>{formatPrice(rowBaseTotal)}</LineThroughText>
        )}
        <Text>{formatPrice(rowTotal)}</Text>
      </Box>
    </Box>
  );
};
